<template>
  <div class="tab-pane-content">
    <div class="section-header">
      <div class="section-header__icon section-header__icon--warning">
        <feather-icon
          icon="FileTextIcon"
          size="20"
        />
      </div>
      <div>
        <h4 class="mb-0">
          Documents & IDs
        </h4>
        <small class="text-muted">Manage your passport, visa, and labour card details</small>
      </div>
    </div>

    <!-- Passport Section -->
    <div class="doc-section mt-2">
      <div class="doc-section__header">
        <feather-icon
          icon="BookOpenIcon"
          size="16"
          class="mr-50 text-primary"
        />
        <h5 class="mb-0">
          Passport
        </h5>
      </div>
      <b-row class="mt-1">
        <b-col
          cols="12"
          md="4"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="HashIcon"
              size="14"
              class="mr-50 text-primary"
            />
            Passport Number
          </label>
          <b-form-input
            v-model="form.passport_number"
            placeholder="Enter passport number"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="CalendarIcon"
              size="14"
              class="mr-50 text-success"
            />
            Issue Date
          </label>
          <b-form-datepicker
            v-model="form.passport_issue_date"
            placeholder="Select date"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="CalendarIcon"
              size="14"
              class="mr-50 text-danger"
            />
            Expiry Date
          </label>
          <b-form-datepicker
            v-model="form.passport_expiry_date"
            placeholder="Select date"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          />
        </b-col>
      </b-row>
    </div>

    <!-- Visa Section -->
    <div class="doc-section mt-2">
      <div class="doc-section__header">
        <feather-icon
          icon="CreditCardIcon"
          size="16"
          class="mr-50 text-success"
        />
        <h5 class="mb-0">
          Visa
        </h5>
      </div>
      <b-row class="mt-1">
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="CalendarIcon"
              size="14"
              class="mr-50 text-success"
            />
            Issue Date
          </label>
          <b-form-datepicker
            v-model="form.visa_issue_date"
            placeholder="Select date"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="CalendarIcon"
              size="14"
              class="mr-50 text-danger"
            />
            Expiry Date
          </label>
          <b-form-datepicker
            v-model="form.visa_expiry_date"
            placeholder="Select date"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          />
        </b-col>
      </b-row>
    </div>

    <!-- Labour Card Section -->
    <div class="doc-section mt-2">
      <div class="doc-section__header">
        <feather-icon
          icon="ClipboardIcon"
          size="16"
          class="mr-50 text-warning"
        />
        <h5 class="mb-0">
          Labour Card
        </h5>
      </div>
      <b-row class="mt-1">
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="CalendarIcon"
              size="14"
              class="mr-50 text-success"
            />
            Issue Date
          </label>
          <b-form-datepicker
            v-model="form.labour_card_issue_date"
            placeholder="Select date"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="CalendarIcon"
              size="14"
              class="mr-50 text-danger"
            />
            Expiry Date
          </label>
          <b-form-datepicker
            v-model="form.labour_card_expiry_date"
            placeholder="Select date"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          />
        </b-col>
      </b-row>
    </div>

    <div class="d-flex justify-content-end mt-2 pt-1 border-top">
      <b-button
        variant="primary"
        class="profile-primary-btn"
        :disabled="isSaving"
        @click="updateProfile"
      >
        <b-spinner
          v-if="isSaving"
          small
          class="mr-50"
        />
        <feather-icon
          v-else
          icon="SaveIcon"
          size="14"
          class="mr-50"
        />
        Save Changes
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentsTab',
  props: {
    form: {
      type: Object,
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: () => false,
    },
    updateProfile: {
      type: Function,
      required: true,
    },
  },
}
</script>
<!-- eof -->
<!-- eof2 -->
